const isProduction = process.env.NODE_ENV === "production";

// warn/error stay on in production so API-call failures (http-client logs them
// via logger.error) are visible when debugging live. log/info/debug are dev
// chatter and would spam a real user's console, so they remain gated.
export const logger = {
  log: (...args: unknown[]) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  info: (...args: unknown[]) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },
  error: (...args: unknown[]) => {
    console.error(...args);
  },
  debug: (...args: unknown[]) => {
    if (!isProduction) {
      console.debug(...args);
    }
  },
};
